<template>
    <div class="container">
      <div class="navbar">
        <NavBar />
      </div>
      <div class="HotControls">
        <div class="user-heading" style="text-align: left">
          <h2 style="font-weight: 600; font-size: larger">HotControls</h2>
        </div>
  
        <div class="input-filter">
          <el-input
            v-model="filterKeyword"
            clearable
            style="width: 250px"
            class="w-50 m-2"
            placeholder="Filter by Plan Name"
          />
        </div>
        
        <!-- <div class="line"> -->
        <table style="width: 100%;">
          <thead>
            <tr>
              <th>Name</th>
              <th>Value</th>
              <th>Category</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="index" class="table-row">
              <td>
                <input
                  :disabled="!row.is_editable"
                  v-model="row.name"
                  class="input-field"
                />
              </td>
              <td>
                <input
                  :disabled="!row.is_editable"
                  v-model="row.value"
                  class="input-field"
                />
              </td>
              <td>{{ row.category }}</td>
  
              <td>
                <input
                  :disabled="!row.is_editable"
                  v-model="row.description"
                  class="input-field"
                />
              </td>
              <td>
                <div class="icons" style="display: flex">
                  <!-- Edit Icon -->
                  <div style="margin: 1px">
                    <el-icon
                      :svg-class="['el-icon-edit']"
                      style="margin-right: 1px"
                      @click="editDetails(index)"
                    >
                      <Edit />
                    </el-icon>
                  </div>
  
                  <!-- Save Icon -->
                  <div style="margin: 1px">
                    <el-icon
                      :svg-class="[
                        'el-icon-save',
                        { 'disabled-icon': !row.is_modified },
                      ]"
                      style="margin-right: 1px"
                      @click="saveRow(index)"
                    >
                    <Collection />
                    </el-icon>
                  </div>
  
                  <!-- Delete Icon -->
                  <div style="margin: 1px">
                    <el-icon
                      class="el-icon-delete"
                      style="margin-right: 1px"
                      @click="deleteRow(index)"
                    >
                      <Delete />
                    </el-icon>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <NoData style="padding: 20px;" v-if="!tableData.length && !is_tableData_loading"></NoData> -->
      <!-- </div> -->
        <!-- Plus button for Add new row  -->
        <div class="add-row-button">
          <button @click="addNewRow"><i class="el-icon-plus"></i>+</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import NavBar from "@/components/NavBar.vue";
  import { serverAddr } from "@/networkConfig";
  
  export default {
    components: { NavBar},
    data() {
      return {
        tableData: [],
        filterKeyword: "",
        is_tableData_loading:false,
        userProfile: {},
      };
    },
    mounted() {
      this.getHotControlData();
    },
    methods: {
      async editDetails(index) {
        this.tableData[index].is_editable = true;
        this.tableData[index].is_modified = true;
      },
      saveRow(index) {
        var rowData = this.tableData[index];
        if (rowData.is_modified) {
          var id = rowData.id;
          var api_string = id
            ? `base/admin/v1/hotcontrol/${rowData.id}`
            : `base/admin/v1/hotcontrol`;
          serverAddr
            .post(api_string, {
              category: rowData.category,
              name: rowData.name,
              value: rowData.value,
              description: rowData.description,
            })
            .then(() => {
              this.$set(this.tableData[index], "is_editable", false);
              this.$set(this.tableData[index], "is_modified", false);
  
              ElNotification({
                // Notification for successfull
                title: "Successful",
                message: "Details saved successfully",
                type: "success",
              });
            })
            .catch((error) => {
              console.log(error);
  
              ElNotification({
                // NOtification for failed
                title: "Failed",
                message: "An error occurred while saving the row",
                type: "Warning",
              });
            });
        }
      },
      deleteRow(index) {
        this.tableData.splice(index, 1);
  
        ElNotification({
          // NOtification for Delete success
          title: "Successfull",
          message: "Details deleted successfully",
          type: "Success",
        });
      },
      getHotControlData() {
        this.is_entries_loading = true;
        serverAddr
          .get(`base/admin/v1/hotcontrol`)
          .then((response) => {
            this.tableData = response.data.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      addNewRow() {
        var newRow = {
          is_editable: true,
          category: "PRICER",
          name: "",
          value: "",
          description: "",
        };
        this.tableData.push(newRow);
      },
      fetchUserProfile() {
      const profileData = localStorage.getItem("profileData");
      if (profileData) {
        this.userProfile = JSON.parse(profileData);
      }
    },
    },

    created() {
      this.fetchUserProfile();
    },
  };
  </script>
  
  <style scoped>
  .body {
    background-color: rgb(123, 116, 116);
    font-family: "Poppins", sans-serif;
  }
  .container {
    max-width: 100%;
    /* padding: 10px; */
  }
  
  .HotControls {
    border-radius: 15px;
    border-spacing: 0;
    margin-top: 85px;
    margin-left: 25px;
    margin-right: 25px;
    padding: 5px 20px 20px 20px;
    background-color: #ffffff;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    /* font-size: 0.8rem; */
  }
  /*.user-heading {
       margin-left: 15px; 
    }*/
  
  .input-filter {
    float:right;
    margin-bottom: 10px;
    
  }
  /* el-input {
    margin-top:10px;
    margin-right: 10px;
  } */
  .table-row {
    border-bottom: 1px solid #e0e0e0;
  }
  
  .table-row:hover {
    background-color: #f0f0f0;
  }
  .icons {
    cursor: pointer;
    margin-left: 20px;
    
  }
  
  thead {
    height: 50px;
    background-color: rgb(243, 233, 242);
    margin-bottom: 50px;
  }
  .input-field {
    width: 90%;
    padding: 5px;
    border-radius: 4px;
    margin-top: 2px;
    margin-bottom: 2px;
    border: 1px solid #ccc;
    background-color: #fff;
    transition: border-color 0.3s;
  }
  .input-field:disabled {
    background-color: #f9f9f9;
    border-color: transparent;
    cursor: not-allowed;
  }
  .add-row-button {
    width: 20px;
    text-align: left;
    padding: 20px 0;
    margin-left: 50px;
    padding-left: 15px;
  }
  .add-row .icon {
    color: #007bff;
    font-size: 20px;
    cursor: pointer;
  }
  .add-row .icon:hover {
    color: #0056b3;
  }
  .line {
    border-bottom: 3px solid rgb(243,233,242);
    border-top: 3px solid rgb(243,233,242);
    /* margin-bottom: 10px; */
    margin-top: 10px;
    padding-top: 3px;
    /* padding-bottom: 3px; */
    /* height: 445px; */
  }
  @media screen and (max-width: 768px) {
    /* .HotControls {
      margin-left: 10px;
      margin-right: 10px;
    } */
    .table-responsive {
      overflow-x: auto;
    }
    table {
      width: 100%;
      border-collapse: collapse;
    }
    th,
    td {
      white-space: nowrap;
    }
    th {
      background-color: #f2f2f2;
    }
    th,
    td {
      padding: 8px;
    }
    
  }
  </style>
  